import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var ContainerInner = styled.div.withConfig({
  displayName: "ContainerInner",
  componentId: "sc-2wvx2d-0"
})(["width:100%;", ";", ";", ""], maxMediaQueries.miniDesktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref) {
  var reverse = _ref.reverse;
  return reverse && "\n      display: flex;\n      flex-direction: column-reverse;\n    ";
}), minMediaQueries.miniDesktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n    max-width: ", ";\n    margin: 0 auto ", "px auto;\n    ", "\n  "])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.maxWidth;
}, function (_ref3) {
  var _ref3$noMargin = _ref3.noMargin,
    noMargin = _ref3$noMargin === void 0 ? false : _ref3$noMargin;
  return noMargin ? 0 : 30;
}, function (_ref4) {
  var _ref4$withInsideNavig = _ref4.withInsideNavigation,
    withInsideNavigation = _ref4$withInsideNavig === void 0 ? false : _ref4$withInsideNavig;
  return withInsideNavigation ? 'margin-top: 60px;' : '';
}), function (_ref5) {
  var _ref5$withInsideNavig = _ref5.withInsideNavigation,
    withInsideNavigation = _ref5$withInsideNavig === void 0 ? false : _ref5$withInsideNavig;
  return withInsideNavigation ? 'margin-top: 60px;' : '';
});